import React, { useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Box, Stack, Typography, Alert, LinearProgress } from '@mui/material'
import RateReviewOutlinedIcon from '@mui/icons-material/RateReviewOutlined'
import SwapHorizIcon from '@mui/icons-material/SwapHoriz'
import PageTitle from '../../../components/PageTitle'
import { KpiRow, Pill, SectionCard, ActionIconBtn } from '../components/common'
import DataTable from '../components/Tables'
import TransferOwnershipDialog from '../components/TransferOwnershipDialog'
import { PATHS } from '../constants'
import { useListAllProposalsQuery } from '../../../redux/d2cApiSlice'
import { proposalRow, inGroup, computeKpis } from '../apiMap'

export default function FHApprovalQueue() {
  const navigate = useNavigate()
  const [transfer, setTransfer] = useState(null)
  const { data, isLoading, isError, error } = useListAllProposalsQuery({ page: 0, size: 100 })
  const rows = useMemo(() => {
    const mapped = Array.isArray(data) ? data.map(proposalRow).filter((r) => inGroup('fhQueue', r.apiStatus)) : []
    return [...mapped].sort((a, b) => new Date(b.raw?.updatedAt || 0) - new Date(a.raw?.updatedAt || 0)) // most recently changed first
  }, [data])
  const kpis = useMemo(() => computeKpis(data, 'fh'), [data])

  const openReview = (r) => navigate(PATHS.fhReview, { state: { proposalId: r.proposalId, versionId: r.versionId, brand: r.brand, card: r.card, orderDataFileUri: r.orderDataFileUri, status: r.apiStatus } })
  const columns = [
    { key: 'brand', label: 'Brand', render: (r) => <b>{r.brand}</b> },
    { key: 'sl', label: 'Sales Leader' },
    { key: 'from', label: 'Came from' },
    {
      key: 'why', label: 'Why it needs you', render: (r) => (
        <Box>
          <Pill label={r.why} styleKey={r.whyKey} />
          {r.whyDetail && <Typography sx={{ fontSize: 12, color: 'text.secondary', mt: 0.25 }}>{r.whyDetail}</Typography>}
        </Box>
      ),
    },
    { key: 'margin', label: 'Margin (exact)', align: 'right' },
    { key: 'waiting', label: 'Waiting', align: 'right' },
    { key: 'sent', label: 'Last updated', align: 'right' },
    {
      key: 'a', label: 'Action', align: 'right', render: (r) => (
        <Stack direction="row" spacing={0.5} justifyContent="flex-end">
          <ActionIconBtn title="Review" onClick={() => openReview(r)}><RateReviewOutlinedIcon fontSize="small" /></ActionIconBtn>
          <ActionIconBtn title="Transfer" onClick={() => setTransfer(r)}><SwapHorizIcon fontSize="small" /></ActionIconBtn>
        </Stack>
      ),
    },
  ]
  return (
    <Box sx={{ px: 3 }}>
      <PageTitle>Approval Queue — Functional Head</PageTitle>
      <KpiRow items={kpis} />
      {isLoading && <LinearProgress sx={{ my: 1 }} />}
      {isError && <Alert severity="error" sx={{ my: 1 }}>{error?.message || 'Failed to load the queue.'}</Alert>}
      <SectionCard title="Approval Queue — Functional Head" subtitle="Everything that needs your sign-off: workings Pricing edited, deals below 10% rebuilt on order-level data, and deals L1 escalated to you. You have every L1 capability — plus your decision is final.">
        <DataTable columns={columns} rows={rows} getRowKey={(r) => r.id} emptyText={isLoading ? 'Loading…' : 'Queue is clear'} />
      </SectionCard>
      <TransferOwnershipDialog open={!!transfer} proposalId={transfer?.proposalId} brand={transfer?.brand} onClose={() => setTransfer(null)} />
    </Box>
  )
}
